import { useEffect } from "react";

/**
 * Hook leve de SEO que atualiza document.title, meta description e Open Graph
 * sem precisar instalar react-helmet. Google indexa SPAs via JS, então isso
 * é suficiente para search. Para WhatsApp/Facebook preview com dados dinâmicos
 * seria necessário SSR; não é escopo neste momento.
 *
 * Uso:
 *   usePageMeta({
 *     title: "VAI PEDE — Cardápio digital...",
 *     description: "Peça já pelo cardápio digital...",
 *     image: "/og-image.png",
 *     url: window.location.href,
 *   });
 */
export default function usePageMeta({ title, description, image, url } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const prevValues = {};

    const setMeta = (selector, attr, value) => {
      if (value == null) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector.replace(/[[\]"]/g, "").split("=");
        el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      prevValues[selector] = el.getAttribute(attr);
      el.setAttribute(attr, value);
    };

    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', "content", description);
    if (title) setMeta('meta[property="og:title"]', "content", title);
    if (description) setMeta('meta[property="og:description"]', "content", description);
    if (image) setMeta('meta[property="og:image"]', "content", image);
    if (url) setMeta('meta[property="og:url"]', "content", url);
    if (title) setMeta('meta[name="twitter:title"]', "content", title);
    if (description) setMeta('meta[name="twitter:description"]', "content", description);
    if (image) setMeta('meta[name="twitter:image"]', "content", image);

    return () => {
      document.title = prevTitle;
      Object.entries(prevValues).forEach(([sel, val]) => {
        const el = document.head.querySelector(sel);
        if (el && val != null) el.setAttribute("content", val);
      });
    };
  }, [title, description, image, url]);
}
